<template>
  <div @click="goToUserInfo">
    <v-image class="user-photo hover-scale"
             :class="{'is-broadcaster' : isBroadcaster, 'is-redirect': isRedirect}"
             :image-id="user.idImage"
             :default="'DefaultUserPhoto.svg'"
    />
  </div>
</template>
<script>

import VImage from './VImage'

export default {
  components: { VImage },
  props: {
    user: {
      type: Object,
      required: true
    },
    redirectToProfil: {
      type: Boolean,
      default: true
    },
    isBroadcaster: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    isRedirect() {
      return this.redirectToProfil && this.user.anonymizedAt == null
    }
  },
  methods: {
    goToUserInfo() {
      if (this.isRedirect) {
        this.$router.push({ name: 'userInfo', params: { id: this.user.id } })
        this.$emit('click')
      }
    }
  }
}
</script>
<style scoped lang="scss">
.user-photo {
  border-radius: 100%;
  height: 100%;
  border: rgba(100,100,100,0.1) solid 1px;
}

.is-redirect {
  cursor: pointer;
}

.is-broadcaster {
  box-shadow: 0 0 0 1.5px $primary-color;
}
</style>
